module.exports = __webpack_public_path__ + "img/22.e1555efa.png";